import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Add a small timeout to ensure DOM has updated before scrolling
    // This helps with more reliable scrolling behavior across browsers
    setTimeout(() => {
      try {
        // Try the modern approach first with options
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'auto' // 'auto' is more reliable than 'instant' for cross-browser compatibility
        });
      } catch (error) {
        // Fallback for older browsers that don't support scrollTo with options
        window.scrollTo(0, 0);
      }
    }, 0);
  }, [pathname]); // Re-run effect whenever the pathname changes

  return null; // This component doesn't render anything visually
}

export default ScrollToTop;